export const US_COUNTRY_ISO_CODE = "840"

export const COUNTRY_CODE_PRIORITY = [
  US_COUNTRY_ISO_CODE,
  "124",
  "356",
  "156",
  "826",
  "380",
  "458",
  "248",
  "410",
  "484",
  "008",
]

export const COUNTRY_CODE_PRIORITY_INDEX_MAP = new Map<string, number>(
  COUNTRY_CODE_PRIORITY.map((code, index) => [code, index])
)
